var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sedap-registration-type-modal",
      attrs: {
        visible: _vm.visible,
        width: _vm.width,
        "show-close": _vm.showClose,
        "close-on-click-modal": _vm.closeOnClickOutside,
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c(
                "h6",
                { staticClass: "sedap-registration-type-modal__title" },
                [_vm._v(_vm._s(_vm.title))]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "sedap-registration-type-modal__list" },
        _vm._l(_vm.options, function(option) {
          return _c(
            "li",
            {
              key: option.key,
              on: {
                click: function($event) {
                  return _vm.$emit("onRegistrationSelected", option.key)
                }
              }
            },
            [_vm._v("\n     " + _vm._s(option.label) + "\n   ")]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9c5b638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9c5b638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/RegistrationType/RegistrationType.vue
// module id = null
// module chunks = 